module.exports = __webpack_public_path__ + "img/refresh.93893bda.svg";